module.exports = __webpack_public_path__ + "media/images/lb/425-beed46bace0f2029bc9cbf94b51ca70b.svg";